"use client";

import { Address } from "@features/venue/types";
import { MapPinIcon } from "@heroicons/react/20/solid";
import { Button } from "@components/theming";
import { useHydrated } from "@utils/hooks";

interface Props {
  address: Address;
}

export default function VenueMapLink({ address }: Props) {
  const hydrated = useHydrated();
  const isIOS = hydrated ? navigator.userAgent.includes("like Mac") : false;

  return (
    <Button
      variant="soft"
      shopsiteVariant="soft"
      size="2"
      href={`${
        isIOS ? "maps" : "https"
      }://maps.google.com/maps/search/?api=1&query=${address.lat}%2C${
        address.long
      }`}
      whitelabelClasses="h-fit py-[var(--space-1)] px-[calc(var(--space-2)*1.25)] shrink justify-start text-left"
      shopsiteClasses="!p-1 gap-1 leading-6 !rounded-lg text-sm !font-medium"
    >
      <MapPinIcon className="w-5 h-5 shrink-0" />
      <span>
        {[address.line1, address.line2, address.line3]
          .filter((line) => line)
          .join(", ")}
      </span>
    </Button>
  );
}
